class AppConfig {
    get isProductionBuild(): boolean {
        return import.meta.env.PROD
    }

    get env(): string {
        if (this.isEnvLocal) {
            return 'Development'
        } else if (this.isEnvDevelopment) {
            return 'RemoteDev'
        } else if (this.isEnvQA) {
            return 'RemoteQa'
        } else if (this.isEnvProduction) {
            return 'RemoteProd'
        } else {
            return 'Unknown'
        }
    }

    get isEnvLocal(): boolean {
        return this.isEnv(['localhost', '127.0.0.1'])
    }

    get isEnvDevelopment(): boolean {
        return this.isEnv(['dev'])
    }

    get isEnvQA(): boolean {
        return this.isEnv(['qa'])
    }

    get isEnvProduction(): boolean {
        return this.isEnv(['prod'])
    }

    private isEnv(envs: string[]): boolean {
        const url = import.meta.env.VITE_APP_API_URL
        if (url) {
            return envs.some(env => url.includes(env))
        } else {
            return false
        }
    }

    get isRemoteBackend(): boolean | undefined {
        return import.meta.env.VITE_APP_REMOTE_ENDPOINT === 'true'
    }

    get apiUrl(): string | undefined {
        if (this.isProductionBuild && !this.isRemoteBackend) {
            return `${window.location.origin}/${import.meta.env.VITE_APP_API_URL}`
        }

        return import.meta.env.VITE_APP_API_URL
    }

    get mapboxToken(): string | undefined {
        return import.meta.env.VITE_APP_MAPBOX_TOKEN
    }

    get appInsightsId(): string | undefined {
        return import.meta.env.VITE_APP_APPINSIGHTS_ID
    }

    get googleOAuthClientId(): string | undefined {
        return import.meta.env.VITE_APP_GOOGLE_OAUTH_CLIENT_ID
    }

    get userflowToken(): string | undefined {
        return import.meta.env.VITE_APP_USERFLOW_TOKEN
    }
}

export const appConfig = new AppConfig()
